import React, { useState } from "react";
import { Stack, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckIcon from "@mui/icons-material/Check";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import { Box } from "@mui/system";
import ProblematicFtdsSortBy from "./ProblematicFtdsSortBy";
import ProblematicFtdsSearch from "./ProblematicFtdsSearch";


const ProblematicFtdsFilter = () => {
  const [value, setValue] = useState("Last 12 Month MTD");

  const options = [
    "Last 30 Days",
    "Last 8 Weeks",
    "Last 12 Months Full",
    "Last 12 Month MTD",
  ];

  const handleChange = (_: React.SyntheticEvent, newValue: string | null) => {
    if (newValue) {
      setValue(newValue);
    }
  };
  const formatDate = (date: Date): string => {
    return date.toLocaleDateString("en-GB");
  };

  const getLast30DaysLabel = () => {
    const today = new Date();

    const endDate = new Date(today);
    endDate.setDate(today.getDate() - 1);

    const startDate = new Date(today);
    startDate.setDate(today.getDate() - 31);

    return `Last 30 Days (${formatDate(startDate)} - ${formatDate(endDate)})`;
  };

  const getLast6WeeksLabel = () => {
    const today = new Date();

    const endDate = new Date(today);
    endDate.setDate(today.getDate() - 1);

    const startDate = new Date(today);
    startDate.setDate(today.getDate() - 42);

    return `Last 6 Weeks (${formatDate(startDate)} - ${formatDate(endDate)})`;
  };

  const getDisplayLabel = (option: string): string => {
    switch (option) {
      case "Last 30 Days":
        return getLast30DaysLabel();

      case "Last 6 Weeks":
        return getLast6WeeksLabel();

      default:
        return option;
    }
  };

  const handleExportCSV = () => {
    alert("Download clicked");
  };

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Autocomplete
          size="small"
          options={options}
          value={value}
          onChange={handleChange}
          getOptionLabel={(option) => getDisplayLabel(option)}
          sx={{
            width: "100%",
            "& .MuiInputBase-input": {
              fontSize: typography.Size.Text.sm.$value,
              lineHeight: typography.Line_height.text.sm.$value,
              fontWeight: typography.Font_weight.Semibold.$value,
              py: "0px !important",
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: spacing.Radius.md.$value,
              "&.Mui-focused fieldset": {
                borderColor: colors.GrayLightMode[300].$value,
                borderWidth: "1px",
              },
            },
          }}
          renderOption={(props, option, { selected }) => (
            <li
              {...props}
              style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: spacing.Spacing["5xl"].$value,
                position: "relative",
                backgroundColor: selected ? colors.Brand[50].$value : "",
              }}
            >
              {selected && (
                <CheckIcon
                  fontSize="small"
                  sx={{
                    position: "absolute",
                    left: spacing.Spacing.lg.$value,
                  }}
                />
              )}
              {option}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              color="secondary"
              placeholder="Select Period"
            />
          )}
        />
      </Stack>

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          mt: spacing.Spacing.md.$value,
          color: colors.GrayLightMode[900].$value,
        }}
      >
        <Box>
          <Typography
            display={"flex"}
            alignItems={"center"}
            flexDirection={"row"}
            gap={1}
            sx={{
              fontSize: typography.Size.Text.xs.$value,
              fontWeight: typography.Font_weight.Regular.$value,
            }}
          >
            Sort by: <ProblematicFtdsSortBy />
          </Typography>
          <Typography
            sx={{
              fontSize: typography.Size.Text.xs.$value,
              mt: spacing.Spacing.sm.$value,
            }}
          >
            2 Brands
          </Typography>
        </Box>

        <Box>
          <ProblematicFtdsSearch/>
          <IconButton color="secondary" size="large" onClick={handleExportCSV}>
            <FileDownloadIcon
              sx={{ color: colors.GrayLightMode[700].$value }}
            />
          </IconButton>
        </Box>
      </Stack>
    </>
  );
};

export default ProblematicFtdsFilter;
